import ring2 from '../elements/ring2.js';
ring2.register();
